import { render, staticRenderFns } from "./fileEditDropdown.vue?vue&type=template&id=105cb20c&scoped=true"
import script from "./fileEditDropdown.vue?vue&type=script&lang=js"
export * from "./fileEditDropdown.vue?vue&type=script&lang=js"
import style0 from "./fileEditDropdown.vue?vue&type=style&index=0&id=105cb20c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105cb20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('105cb20c')) {
      api.createRecord('105cb20c', component.options)
    } else {
      api.reload('105cb20c', component.options)
    }
    module.hot.accept("./fileEditDropdown.vue?vue&type=template&id=105cb20c&scoped=true", function () {
      api.rerender('105cb20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cloudSpace/components/fileEditDropdown.vue"
export default component.exports